<template>
  <NtAlert v-if="show" level="danger" heading="Missing Module">
    Module "{{ component }}" not installed.
    <template #actions>
      <NtButton level="danger" icon="fa-sync" @click="reload"> Reload Hub </NtButton>
    </template>
  </NtAlert>
</template>

<script>
import NtAlert from '@/components/general/NtAlert.vue'
import NtButton from '@/components/general/NtButton.vue'

export default {
  components: { NtAlert, NtButton },
  props: {
    component: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      show: false,
      timeout: null
    }
  },
  mounted() {
    this.timeout = setTimeout(() => {
      this.show = true
    }, 5000)
  },
  beforeUnmount() {
    clearTimeout(this.timeout)
  },
  methods: {
    reload() {
      window.location.reload()
    }
  }
}
</script>
